/** Above site header (1001), chat widget (1050) and nav drawers (1199); below cookie consent (1000001) */
export const APP_MODAL_Z_INDEX = 1000050;

/** Nested academic dialogs (renewal/cancellation/license) rendered on top of the main modal */
export const APP_MODAL_NESTED_Z_INDEX = APP_MODAL_Z_INDEX + 1;
